import { Card, CardContent } from "@/components/ui/card";

export const ServicesGrid = () => {
  const services = [
    {
      title: "Paid Social",
      image: "/lovable-uploads/edb3c016-8649-430a-8ae9-3c10a2d6a199.png",
      description: "Harness the power of social media to drive targeted traffic and brand awareness. Our Paid Social Ad services leverage platforms like Facebook, Instagram, LinkedIn, and Twitter to deliver high-impact ads tailored to your audience's interests and behaviors."
    },
    {
      title: "Paid Search",
      image: "/lovable-uploads/17d54b56-8602-4018-9d23-d6b939454153.png",
      description: "Get your business at the top of search results when it matters most. Our Google Ads & Bing campaigns are designed with precision keyword targeting, ensuring your ads appear when users are actively searching for your products or services."
    },
    {
      title: "Shopping Ads",
      image: "/lovable-uploads/e546d8ab-fbef-4c52-bc17-777bf0499f25.png",
      description: "Showcase your products to high-intent shoppers on the world's largest e-commerce and search platforms. With Google Shopping Ads, your products will appear directly in search results, displaying key details like price and images."
    },
    {
      title: "Retargeting",
      image: "/lovable-uploads/df489293-dc59-4881-848b-50878e6e946e.png",
      description: "Don't let potential customers slip away. With retargeting campaigns, we help you reconnect with visitors who have already shown interest in your brand. Our tailored ads across Google and social platforms remind users of your offering."
    }
  ];

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">AI-Enhanced PPC Solutions For</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="overflow-hidden">
              <div className="relative h-48 w-full">
                <img
                  src={service.image}
                  alt={service.title}
                  className="absolute inset-0 w-full h-full object-contain p-4"
                  onError={(e) => {
                    console.error(`Error loading image for ${service.title}:`, e);
                    e.currentTarget.src = "/placeholder.svg";
                  }}
                />
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-4 text-primary">
                  {service.title}
                </h3>
                <p className="text-gray-700 text-sm">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};